<mat-form-field class="full-width background-white" appearance="outline">
  <mat-label>{{ labelKey | locLabel }}</mat-label>
  <div class="inside">
    <input
      #input
      matInput
      [type]="showPassword ? 'text' : 'password'"
      [disabled]="_disabled"
      [autocomplete]="tag"
      id="{{ tag }} {{ ID_NOISE }}"
      [name]="tag"
      [title]="title"
      [attr.passwordrules]="rules"
      [pattern]="pattern"
      [minlength]="LENGTH"
      [(ngModel)]="value"
      (blur)="_onTouch()"
    />
    <!-- FIXME: don't use [(ngModel)] https://github.com/FlikoAdmin/FlikoWeb/pull/941 -->
    <mat-icon [matTooltip]="(showPassword ? 'passwd.hide' : 'passwd.show') | loc" (click)="showPassword = !showPassword">
      visibility_{{ showPassword ? 'off' : 'on' }}
    </mat-icon>
  </div>
</mat-form-field>
<app-input-footer *ngIf="footer" [control]="ngControl?.control"></app-input-footer>
